import { ResponsivePosterModule } from '@/src/types/common/content';
import { EnumModuleType } from '@/src/types/common/module';
import { amountOfPosters } from '../../util';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import { generateResponsiveImage } from '@/src/constrains/DraggableModules/tools';

type Params = {
  pc: ResponsivePosterModule;
  tablet: ResponsivePosterModule;
  mobile: ResponsivePosterModule;
  moduleType: EnumModuleType;
  changedFields: Array<any>;
};

class PosterStrategy {
  assign(obj: any, target: any) {
    Object.assign(obj, target);
  }

  copyStrategy({ pc, tablet, mobile, breakpoint }: any) {
    const func = (data, target) => {
      const dataPosters = amountOfPosters(data?.posterType);
      const targetPosters = amountOfPosters(target?.posterType);
      const originalList = data?.images || [];
      if (dataPosters > targetPosters) {
        return {
          ...data,
          images: originalList.slice(0, targetPosters),
        };
      } else if (dataPosters < targetPosters) {
        const gap = targetPosters - dataPosters;
        const list = Array.from({ length: gap }).map((_, index) =>
          generateResponsiveImage(`Poster ${dataPosters + index + 1}`),
        );
        return {
          ...data,
          images: [...originalList, ...list],
        };
      } else {
        return data;
      }
    };
    switch (breakpoint) {
      case EPreviewSize.TABLET: {
        return func(pc, tablet);
      }
      case EPreviewSize.MOBILE: {
        return func(pc, mobile);
      }
    }
  }

  invokeStrategy({ pc, tablet, mobile }: Params) {
    const _tablet = tablet;
    const _mobile = mobile;
    const { animation } = pc;
    // if (
    //   Reflect.ownKeys(pc).length > 0 &&
    //   !Reflect.ownKeys(tablet)?.length &&
    //   !Reflect.ownKeys(mobile).length
    // ) {
    //   this.assign(_tablet, {
    //     posterType,
    //     moduleWidth,
    //     leaveGap,
    //     resizingOption,
    //     moduleStyle,
    //   });
    //   this.assign(_mobile, {
    //     posterType,
    //     moduleWidth,
    //     leaveGap,
    //     resizingOption,
    //     moduleStyle,
    //   });
    // }
    this.assign(_tablet, {
      animation,
    });
    this.assign(_mobile, {
      animation,
    });
    return {
      pc,
      tablet: _tablet,
      mobile: _mobile,
    };
  }
}

export default new PosterStrategy();
